import ReactNativeOCRModule from "./ReactNativeOCRModule";

export function hello(): string {
  return ReactNativeOCRModule.hello();
}
